import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api from 'src/services/api'
import {PatchAlarmCenter} from 'src/services/api/endpoints/AlarmCenterEndpoint'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

type UpdateAlarmCenterInput = PatchAlarmCenter & {
  id: number
  clientId: number
}

export default function useUpdateAlarmCenter() {
  const {enqueueSnackbar} = useSnackbar()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: [QueryKeyEnum.UPDATE_ALARM_CENTER],
    mutationFn: async ({id, clientId: _clientId, ...body}: UpdateAlarmCenterInput) => {
      return (await api.alarmCenter.updateOne(id, body)).data.data
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: [QueryKeyEnum.ALARM_CENTERS]})
      enqueueSnackbar('Central de alarme atualizada com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não conseguimos atualizar a central de alarme no momento')
    },
  })
}
